var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2001 18.6V26.2H23.0001V18.6H25.2001Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2001 28.2V31.2H23.0001V28.2H25.2001Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.05 12.3457C21.8744 9.21809 26.3258 9.21809 28.1503 12.3457L28.1526 12.3497L38.5503 30.3457L38.5515 30.3479C40.3737 33.4752 38.1548 37.4 34.5001 37.4H13.7001C10.0455 37.4 7.82651 33.4752 9.64869 30.3479L9.64996 30.3457L20.0477 12.3497L20.05 12.3457ZM21.9513 13.4525L21.9503 13.4543L11.5526 31.4503L11.5503 31.4543C10.5748 33.1266 11.7556 35.2 13.7001 35.2H34.5001C36.4446 35.2 37.6255 33.1266 36.65 31.4543L36.6477 31.4503L26.25 13.4543L26.2489 13.4525C25.2731 11.7825 22.9271 11.7825 21.9513 13.4525Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2,
    height: 27.4,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertLight);
export default __webpack_public_path__ + "static/media/icon_alert_light.feeae774.svg";
export { ForwardRef as ReactComponent };